export function areDifferent(
    values: (string | number | null | undefined)[]
): boolean {
    const nonNullValues = values.filter(
        (v) => v !== null && v !== undefined && v !== ""
    );
    if (nonNullValues.length === 0) return false;
    const firstValue = nonNullValues[ 0 ];
    return nonNullValues.some((v) => v !== firstValue);
}

export function getBestValue(
    values: (string | number | null | undefined)[],
    type: "price" | "warranty" | "quantity" | "default"
): number | null {
    const nonNullValues = values.filter(
        (v): v is number => v !== null && v !== undefined && v !== ""
    ) as number[];
    if (nonNullValues.length === 0) return null;

    if (type === "price") {
        return Math.min(...nonNullValues);
    } else if (type === "warranty") {
        return Math.max(...nonNullValues);
    } else if (type === "quantity") {
        return Math.max(...nonNullValues);
    }
    return null;
}

export function parseProductIds(idsParam: string | null): number[] {
    if (!idsParam) return [];
    return idsParam
        .split(",")
        .map((id) => parseInt(id, 10))
        .filter((id) => !isNaN(id) && id > 0)
        .slice(0, 3); // Max 3 products
}

